import React from 'react';
import './data.css'


function  data () {
    
        return (
            <div>
       <div className="container-fluid dataManagementWrapper">
      <div className="row justify-content-center">
        <div className="">
          <div className="dataManagementContainer">
            {/* <!-- HEADER --> */}
            <div className="dataManagementHeaderSection">
              <div className="dataManagementTitleWrapper">
                <div className="dataManagementTitleText">
                  Quản lý dữ liệu
                </div>

                <div className="dataManagementBreadcrumbWrapper">
                  <div className="dataManagementBreadcrumbText">
                    Trang chủ
                  </div>

                  <div className="dataManagementBreadcrumbDivider">
                    /
                  </div>

                  <div className="dataManagementBreadcrumbText">
                    Quản trị hệ thống
                  </div>

                  <div className="dataManagementBreadcrumbDivider">
                    /
                  </div>

                  <div className="dataManagementBreadcrumbText">
                    Quản lý dữ liệu
                  </div>

                  <div className="dataManagementBreadcrumbDivider">
                    /
                  </div>

                  <div className="dataManagementBreadcrumbText">
                    Quản lý dữ liệu
                  </div>
                </div>
              </div>

              <button className="dataManagementAddButton">
                <i
                  className="fa-solid fa-plus dataManagementAddButtonIcon"
                ></i>

                Thêm dữ liệu
              </button>
            </div>

            {/* <!-- FILTER --> */}
            <div className="dataManagementFilterCard">
              <div className="row">
                <div className="col-sm-2">
                  <label className="dataManagementFilterLabel">
                    Tên dữ liệu
                  </label>

                  <div className="dataManagementFilterInputWrapper">
                    <input
                      type="text"
                      className="dataManagementFilterInput"
                      placeholder="Nhập tên dữ liệu..."
                    />

                    <i
                      className="fa-solid fa-magnifying-glass dataManagementFilterInputIcon"
                    ></i>
                  </div>
                </div>

                <div className="col-sm-2 data-type-wrap">
                  <label className="dataManagementFilterLabel data-type">
                    Loại dữ liệu
                  </label>

                  <select className="dataManagementFilterSelect">
                    <option>-- Tất cả --</option>
                    <option>Dữ liệu nghiệp vụ</option>
                    <option>Dữ liệu hệ thống</option>
                    <option>Dữ liệu báo cáo</option>
                  </select>
                </div>

                <div className="col-sm-2 source-wrap">
                  <label className="dataManagementFilterLabel source">
                    Nguồn dữ liệu
                  </label>

                  <select className="dataManagementFilterSelect">
                    <option>-- Tất cả --</option>
                    <option>Nhập liệu</option>
                    <option>Hệ thống</option>
                    <option>Tích hợp</option>
                  </select>
                </div>

                <div className="col-sm-2 data-status">
                  <label className="dataManagementFilterLabel status-text">
                    Trạng thái
                  </label>

                  <select className="dataManagementFilterSelect">
                    <option>-- Tất cả --</option>
                    <option>Hoạt động</option>
                    <option>Tạm dừng</option>
                  </select>
                </div>

                {/* <!-- DATE --> */}
                {/* <div className="col-sm-2">
                  <label className="dataManagementFilterLabel">
                    Thời gian cập nhật
                  </label>

                  <div className="dataManagementDateWrapper">
                    <input
                      type="date"
                      className="dataManagementDateInput"
                      placeholder="Từ ngày"
                    />

                    <i
                      className="fa-regular fa-calendar dataManagementDateIcon"
                    ></i>
                  </div>
                </div>

                <div className="col-sm-2">
                  <label className="dataManagementFilterLabel">
                    &nbsp;
                  </label>

                  <div className="dataManagementDateWrapper">
                    <input
                      type="date"
                      className="dataManagementDateInput"
                      placeholder="Đến ngày"
                    />

                    <i
                      className="fa-regular fa-calendar dataManagementDateIcon"
                    ></i>
                  </div>
                </div> */}
                 <div className="col-sm-2 time-update">
    <label className="dataFilterDateLabel">
      Thời gian cập nhật
    </label>

    <div className="dataFilterDateWrapper">
      <input
        type="text"
        className="dataFilterDateInput"
        placeholder="Từ ngày"
      />

      <div className="dataFilterDateIconWrapper">
        <i className="fa-regular fa-calendar"></i>
      </div>
    </div>
  </div>

  {/* <!-- ĐẾN NGÀY --> */}
  <div className="col-sm-2">
    <label className="dataFilterDateLabel hiddenLabel">
      Thời gian cập nhật
    </label>

    <div className="dataFilterDateWrapper">
      <input
        type="text"
        className="dataFilterDateInput"
        placeholder="đến ngày"
      />

      <div className="dataFilterDateIconWrapper">
        <i className="fa-regular fa-calendar"></i>
      </div>
    </div>
  </div>
              </div>

              <div className="row mt-4">
                <div className="col-sm-12">
                  <div className="dataManagementFilterButtonWrapper">
                    <button className="dataManagementResetButton">
                      <i className="fa-solid fa-rotate-right icon-rotage-right"></i>

                      Đặt lại
                    </button>

                    <button className="dataManagementSearchButton">
                      <i className="fa-solid fa-magnifying-glass icon-magnifying"></i>

                      Tìm kiếm
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* <!-- TABLE --> */}
            <div className="dataManagementTableCard">
              <div className="dataManagementTableHeader">
                <div className="dataManagementTableTitle">
                  Danh sách dữ liệu
                </div>

                <div className="dataManagementTableActionWrapper">
                  <button className="dataManagementImportButton">
                    <i className="fa-solid fa-upload icon-solid-share"></i>

                    Import dữ liệu
                  </button>

                  <button className="dataManagementExportButton">
                    <i className="fa-solid fa-download icon-solid-share"></i>

                    Export dữ liệu
                  </button>

                  <button className="dataManagementSettingButton">
                    <i className="fa-solid fa-gear"></i>
                  </button>
                </div>
              </div>

              <div className="dataManagementTableResponsive">
                <table className="dataManagementTableElement">
                  <thead>
                    <tr className="dataManagementTableHeadRow">
                      <th className="dataManagementTableHeadCell">
                        STT
                      </th>

                      <th className="dataManagementTableHeadCell">
                        Tên dữ liệu
                      </th>

                      <th className="dataManagementTableHeadCell">
                        Loại dữ liệu
                      </th>

                      <th className="dataManagementTableHeadCell">
                        Nguồn dữ liệu
                      </th>

                      <th className="dataManagementTableHeadCell">
                        Số lượng bản ghi
                      </th>

                      <th className="dataManagementTableHeadCell">
                        Dung lượng
                      </th>

                      <th className="dataManagementTableHeadCell">
                        Trạng thái
                      </th>

                      <th className="dataManagementTableHeadCell">
                        Thời gian cập nhật
                      </th>

                      <th className="dataManagementTableHeadCell">
                        Người cập nhật
                      </th>

                      <th className="dataManagementTableHeadCell">
                        Thao tác
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {/* <!-- 1 --> */}
                    <tr className="dataManagementTableBodyRow">
                      <td className="dataManagementTableBodyCell">
                        1
                      </td>

                      <td className="dataManagementTableBodyCell">
                        <div className="dataManagementTableNameText">
                          Doanh nghiệp
                        </div>
                      </td>

                      <td className="dataManagementTableBodyCell">
                        Dữ liệu nghiệp vụ
                      </td>

                      <td className="dataManagementTableBodyCell">
                        Nhập liệu
                      </td>

                      <td className="dataManagementTableBodyCell">
                        2,456
                      </td>

                      <td className="dataManagementTableBodyCell">
                        12.45 MB
                      </td>

                      <td className="dataManagementTableBodyCell">
                        <span className="dataManagementActiveStatus">
                          Hoạt động
                        </span>
                      </td>

                      <td className="dataManagementTableBodyCell">
                        20/05/2024 10:30
                      </td>

                      <td className="dataManagementTableBodyCell">
                        admin
                      </td>

                      <td className="dataManagementTableBodyCell">
                        <div
                          className="dataManagementActionButtonWrapper"
                        >
                          <button
                            className="dataManagementViewButton"
                          >
                            <i className="fa-regular fa-eye"></i>
                          </button>

                          <button
                            className="dataManagementEditButton"
                          >
                            <i className="fa-solid fa-pen"></i>
                          </button>

                          <button
                            className="dataManagementDeleteButton"
                          >
                            <i
                              className="fa-regular fa-trash-can"
                            ></i>
                          </button>
                        </div>
                      </td>
                    </tr>

                    {/* <!-- 2 --> */}
                    <tr className="dataManagementTableBodyRow">
                      <td className="dataManagementTableBodyCell">
                        2
                      </td>

                      <td className="dataManagementTableBodyCell">
                        <div className="dataManagementTableNameText">
                          Cơ sở sản xuất
                        </div>
                      </td>

                      <td className="dataManagementTableBodyCell">
                        Dữ liệu nghiệp vụ
                      </td>

                      <td className="dataManagementTableBodyCell">
                        Nhập liệu
                      </td>

                      <td className="dataManagementTableBodyCell">
                        1,245
                      </td>

                      <td className="dataManagementTableBodyCell">
                        8.32 MB
                      </td>

                      <td className="dataManagementTableBodyCell">
                        <span className="dataManagementActiveStatus">
                          Hoạt động
                        </span>
                      </td>

                      <td className="dataManagementTableBodyCell">
                        20/05/2024 09:15
                      </td>

                      <td className="dataManagementTableBodyCell">
                        nguyenvana
                      </td>

                      <td className="dataManagementTableBodyCell">
                        <div
                          className="dataManagementActionButtonWrapper"
                        >
                          <button
                            className="dataManagementViewButton"
                          >
                            <i className="fa-regular fa-eye"></i>
                          </button>

                          <button
                            className="dataManagementEditButton"
                          >
                            <i className="fa-solid fa-pen"></i>
                          </button>

                          <button
                            className="dataManagementDeleteButton"
                          >
                            <i
                              className="fa-regular fa-trash-can"
                            ></i>
                          </button>
                        </div>
                      </td>
                    </tr>

                    {/* <!-- 3 --> */}
                    <tr className="dataManagementTableBodyRow">
                      <td className="dataManagementTableBodyCell">
                        3
                      </td>

                      <td className="dataManagementTableBodyCell">
                        <div className="dataManagementTableNameText">
                          Sản phẩm công nghiệp
                        </div>
                      </td>

                      <td className="dataManagementTableBodyCell">
                        Dữ liệu nghiệp vụ
                      </td>

                      <td className="dataManagementTableBodyCell">
                        Nhập liệu
                      </td>

                      <td className="dataManagementTableBodyCell">
                        3,678
                      </td>

                      <td className="dataManagementTableBodyCell">
                        15.67 MB
                      </td>

                      <td className="dataManagementTableBodyCell">
                        <span className="dataManagementActiveStatus">
                          Hoạt động
                        </span>
                      </td>

                      <td className="dataManagementTableBodyCell">
                        19/05/2024 16:45
                      </td>

                      <td className="dataManagementTableBodyCell">
                        tranthibinh
                      </td>

                      <td className="dataManagementTableBodyCell">
                        <div
                          className="dataManagementActionButtonWrapper"
                        >
                          <button
                            className="dataManagementViewButton"
                          >
                            <i className="fa-regular fa-eye"></i>
                          </button>

                          <button
                            className="dataManagementEditButton"
                          >
                            <i className="fa-solid fa-pen"></i>
                          </button>

                          <button
                            className="dataManagementDeleteButton"
                          >
                            <i
                              className="fa-regular fa-trash-can"
                            ></i>
                          </button>
                        </div>
                      </td>
                    </tr>

                    {/* <!-- 4 --> */}
                    <tr className="dataManagementTableBodyRow">
                      <td className="dataManagementTableBodyCell">
                        4
                      </td>

                      <td className="dataManagementTableBodyCell">
                        <div className="dataManagementTableNameText">
                          Thương nhân
                        </div>
                      </td>

                      <td className="dataManagementTableBodyCell">
                        Dữ liệu nghiệp vụ
                      </td>

                      <td className="dataManagementTableBodyCell">
                        Nhập liệu
                      </td>

                      <td className="dataManagementTableBodyCell">
                        987
                      </td>

                      <td className="dataManagementTableBodyCell">
                        6.21 MB
                      </td>

                      <td className="dataManagementTableBodyCell">
                        <span className="dataManagementActiveStatus">
                          Hoạt động
                        </span>
                      </td>

                      <td className="dataManagementTableBodyCell">
                        19/05/2024 14:20
                      </td>

                      <td className="dataManagementTableBodyCell">
                        lethicu
                      </td>

                      <td className="dataManagementTableBodyCell">
                        <div
                          className="dataManagementActionButtonWrapper"
                        >
                          <button
                            className="dataManagementViewButton"
                          >
                            <i className="fa-regular fa-eye"></i>
                          </button>

                          <button
                            className="dataManagementEditButton"
                          >
                            <i className="fa-solid fa-pen"></i>
                          </button>

                          <button
                            className="dataManagementDeleteButton"
                          >
                            <i
                              className="fa-regular fa-trash-can"
                            ></i>
                          </button>
                        </div>
                      </td>
                    </tr>

                    {/* <!-- 5 --> */}
                    <tr className="dataManagementTableBodyRow">
                      <td className="dataManagementTableBodyCell">
                        5
                      </td>

                      <td className="dataManagementTableBodyCell">
                        <div className="dataManagementTableNameText">
                          Báo cáo thống kê
                        </div>
                      </td>

                      <td className="dataManagementTableBodyCell">
                        Dữ liệu báo cáo
                      </td>

                      <td className="dataManagementTableBodyCell">
                        Hệ thống
                      </td>

                      <td className="dataManagementTableBodyCell">
                        456
                      </td>

                      <td className="dataManagementTableBodyCell">
                        3.12 MB
                      </td>

                      <td className="dataManagementTableBodyCell">
                        <span className="dataManagementActiveStatus">
                          Hoạt động
                        </span>
                      </td>

                      <td className="dataManagementTableBodyCell">
                        18/05/2024 11:10
                      </td>

                      <td className="dataManagementTableBodyCell">
                        system
                      </td>

                      <td className="dataManagementTableBodyCell">
                        <div
                          className="dataManagementActionButtonWrapper"
                        >
                          <button
                            className="dataManagementViewButton"
                          >
                            <i className="fa-regular fa-eye"></i>
                          </button>

                          <button
                            className="dataManagementEditButton"
                          >
                            <i className="fa-solid fa-pen"></i>
                          </button>

                          <button
                            className="dataManagementDeleteButton"
                          >
                            <i
                              className="fa-regular fa-trash-can"
                            ></i>
                          </button>
                        </div>
                      </td>
                    </tr>

                    {/* <!-- 6 --> */}
                    <tr className="dataManagementTableBodyRow">
                      <td className="dataManagementTableBodyCell">
                        6
                      </td>

                      <td className="dataManagementTableBodyCell">
                        <div className="dataManagementTableNameText">
                          Dữ liệu giấy phép
                        </div>
                      </td>

                      <td className="dataManagementTableBodyCell">
                        Dữ liệu nghiệp vụ
                      </td>

                      <td className="dataManagementTableBodyCell">
                        Tích hợp
                      </td>

                      <td className="dataManagementTableBodyCell">
                        789
                      </td>

                      <td className="dataManagementTableBodyCell">
                        4.78 MB
                      </td>

                      <td className="dataManagementTableBodyCell">
                        <span className="dataManagementPauseStatus">
                          Tạm dừng
                        </span>
                      </td>

                      <td className="dataManagementTableBodyCell">
                        18/05/2024 10:05
                      </td>

                      <td className="dataManagementTableBodyCell">
                        system
                      </td>

                      <td className="dataManagementTableBodyCell">
                        <div
                          className="dataManagementActionButtonWrapper"
                        >
                          <button
                            className="dataManagementViewButton"
                          >
                            <i className="fa-regular fa-eye"></i>
                          </button>

                          <button
                            className="dataManagementEditButton"
                          >
                            <i className="fa-solid fa-pen"></i>
                          </button>

                          <button
                            className="dataManagementDeleteButton"
                          >
                            <i
                              className="fa-regular fa-trash-can"
                            ></i>
                          </button>
                        </div>
                      </td>
                    </tr>

                    {/* <!-- 7 --> */}
                    <tr className="dataManagementTableBodyRow">
                      <td className="dataManagementTableBodyCell">
                        7
                      </td>

                      <td className="dataManagementTableBodyCell">
                        <div className="dataManagementTableNameText">
                          Dữ liệu nhật ký
                        </div>
                      </td>

                      <td className="dataManagementTableBodyCell">
                        Dữ liệu hệ thống
                      </td>

                      <td className="dataManagementTableBodyCell">
                        Hệ thống
                      </td>

                      <td className="dataManagementTableBodyCell">
                        15,678
                      </td>

                      <td className="dataManagementTableBodyCell">
                        25.45 MB
                      </td>

                      <td className="dataManagementTableBodyCell">
                        <span className="dataManagementActiveStatus">
                          Hoạt động
                        </span>
                      </td>

                      <td className="dataManagementTableBodyCell">
                        20/05/2024 10:30
                      </td>

                      <td className="dataManagementTableBodyCell">
                        system
                      </td>

                      <td className="dataManagementTableBodyCell">
                        <div
                          className="dataManagementActionButtonWrapper"
                        >
                          <button
                            className="dataManagementViewButton"
                          >
                            <i className="fa-regular fa-eye"></i>
                          </button>

                          <button
                            className="dataManagementEditButton"
                          >
                            <i className="fa-solid fa-pen"></i>
                          </button>

                          <button
                            className="dataManagementDeleteButton"
                          >
                            <i
                              className="fa-regular fa-trash-can"
                            ></i>
                          </button>
                        </div>
                      </td>
                    </tr>

                    {/* <!-- 8 --> */}
                    <tr className="dataManagementTableBodyRow">
                      <td className="dataManagementTableBodyCell">
                        8
                      </td>

                      <td className="dataManagementTableBodyCell">
                        <div className="dataManagementTableNameText">
                          Dữ liệu danh mục
                        </div>
                      </td>

                      <td className="dataManagementTableBodyCell">
                        Dữ liệu hệ thống
                      </td>

                      <td className="dataManagementTableBodyCell">
                        Hệ thống
                      </td>

                      <td className="dataManagementTableBodyCell">
                        234
                      </td>

                      <td className="dataManagementTableBodyCell">
                        1.45 MB
                      </td>

                      <td className="dataManagementTableBodyCell">
                        <span className="dataManagementActiveStatus">
                          Hoạt động
                        </span>
                      </td>

                      <td className="dataManagementTableBodyCell">
                        20/05/2024 08:50
                      </td>

                      <td className="dataManagementTableBodyCell">
                        admin
                      </td>

                      <td className="dataManagementTableBodyCell">
                        <div
                          className="dataManagementActionButtonWrapper"
                        >
                          <button
                            className="dataManagementViewButton"
                          >
                            <i className="fa-regular fa-eye"></i>
                          </button>

                          <button
                            className="dataManagementEditButton"
                          >
                            <i className="fa-solid fa-pen"></i>
                          </button>

                          <button
                            className="dataManagementDeleteButton"
                          >
                            <i
                              className="fa-regular fa-trash-can"
                            ></i>
                          </button>
                        </div>
                      </td>
                    </tr>

                    {/* <!-- 9 --> */}
                    <tr className="dataManagementTableBodyRow">
                      <td className="dataManagementTableBodyCell">
                        9
                      </td>

                      <td className="dataManagementTableBodyCell">
                        <div className="dataManagementTableNameText">
                          Dữ liệu tích hợp QG
                        </div>
                      </td>

                      <td className="dataManagementTableBodyCell">
                        Dữ liệu tích hợp
                      </td>

                      <td className="dataManagementTableBodyCell">
                        Tích hợp
                      </td>

                      <td className="dataManagementTableBodyCell">
                        1,567
                      </td>

                      <td className="dataManagementTableBodyCell">
                        9.87 MB
                      </td>

                      <td className="dataManagementTableBodyCell">
                        <span className="dataManagementActiveStatus">
                          Hoạt động
                        </span>
                      </td>

                      <td className="dataManagementTableBodyCell">
                        17/05/2024 15:30
                      </td>

                      <td className="dataManagementTableBodyCell">
                        system
                      </td>

                      <td className="dataManagementTableBodyCell">
                        <div
                          className="dataManagementActionButtonWrapper"
                        >
                          <button
                            className="dataManagementViewButton"
                          >
                            <i className="fa-regular fa-eye"></i>
                          </button>

                          <button
                            className="dataManagementEditButton"
                          >
                            <i className="fa-solid fa-pen"></i>
                          </button>

                          <button
                            className="dataManagementDeleteButton"
                          >
                            <i
                              className="fa-regular fa-trash-can"
                            ></i>
                          </button>
                        </div>
                      </td>
                    </tr>

                    {/* <!-- 10 --> */}
                    <tr className="dataManagementTableBodyRow">
                      <td className="dataManagementTableBodyCell">
                        10
                      </td>

                      <td className="dataManagementTableBodyCell">
                        <div className="dataManagementTableNameText">
                          Dữ liệu người dùng
                        </div>
                      </td>

                      <td className="dataManagementTableBodyCell">
                        Dữ liệu hệ thống
                      </td>

                      <td className="dataManagementTableBodyCell">
                        Hệ thống
                      </td>

                      <td className="dataManagementTableBodyCell">
                        326
                      </td>

                      <td className="dataManagementTableBodyCell">
                        2.11 MB
                      </td>

                      <td className="dataManagementTableBodyCell">
                        <span className="dataManagementActiveStatus">
                          Hoạt động
                        </span>
                      </td>

                      <td className="dataManagementTableBodyCell">
                        20/05/2024 07:45
                      </td>

                      <td className="dataManagementTableBodyCell">
                        admin
                      </td>

                      <td className="dataManagementTableBodyCell">
                        <div
                          className="dataManagementActionButtonWrapper"
                        >
                          <button
                            className="dataManagementViewButton"
                          >
                            <i className="fa-regular fa-eye"></i>
                          </button>

                          <button
                            className="dataManagementEditButton"
                          >
                            <i className="fa-solid fa-pen"></i>
                          </button>

                          <button
                            className="dataManagementDeleteButton"
                          >
                            <i
                              className="fa-regular fa-trash-can"
                            ></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* <!-- PAGINATION --> */}
              <div className="dataManagementPaginationWrapper">
                <div className="dataManagementPaginationLeft">
                  <div className="dataManagementPaginationText">
                    Hiển thị
                  </div>

                  <select
                    className="dataManagementPaginationSelect"
                  >
                    <option>10</option>
                  </select>

                  <div className="dataManagementPaginationText">
                    dòng trên mỗi trang
                  </div>
                </div>

                <div className="dataManagementPaginationRight">
                  <div className="dataManagementPaginationInfo">
                    1 - 10 trong 25
                  </div>

                  <button
                    className="dataManagementPaginationButton"
                  >
                    <i className="fa-solid fa-angle-left"></i>
                  </button>

                  <button
                    className="dataManagementPaginationButton dataManagementPaginationButtonActive"
                  >
                    1
                  </button>

                  <button
                    className="dataManagementPaginationButton"
                  >
                    2
                  </button>

                  <button
                    className="dataManagementPaginationButton"
                  >
                    3
                  </button>

                  <button
                    className="dataManagementPaginationButton"
                  >
                    <i className="fa-solid fa-angle-right"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
            </div>
        );
    
}



export default data;